import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

class PAUTItemForm extends Form {
	state = {
		data: {
			thickness: '',
			group: '',
			probeID: '',
			wedge: '',
			startElement: '',
			qty: '',
			lastElement: '',
			angle: '',
			db: '',
			frequency: '',
			manufacturer: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		thickness: Joi.number().positive().required().label('Thickness'),
		group: Joi.string().min(3).required().label('Group'),
		probeID: Joi.string().min(3).required().label('Probe ID'),
		wedge: Joi.string().required().label('Wedge'),
		startElement: Joi.number().positive().required().label('Start Element'),
		qty: Joi.number().positive().required().label('Element Quantity'),
		lastElement: Joi.number().required().label('Last Element'),
		angle: Joi.string().required().label('Angle'),
		db: Joi.number().positive().required().label('dB'),
		frequency: Joi.number().positive().required().label('Frequency (MHZ)'),
		manufacturer: Joi.string().min(3).required().label('Manufacturer'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({
			data: {
				thickness: '',
				group: '',
				probeID: '',
				wedge: '',
				startElement: '',
				qty: '',
				lastElement: '',
				angle: '',
				db: '',
				frequency: '',
				manufacturer: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'thickness',
							type: 'number',
							label: 'Thickness',
							placeholder: 'Enter Thickness',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'group',
							label: 'Group',
							placeholder: 'Enter Group',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'probeID',
							label: 'Probe ID',
							placeholder: 'e.g. Enter Probe ID',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'wedge',
							label: 'Wedge',
							placeholder: 'Enter Wedge',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'startElement',
							type: 'number',
							label: 'Start Element',
							placeholder: 'Enter Start Element',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'qty',
							label: 'Element Quantity',
							placeholder: 'Enter Element Quantity',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'lastElement',
							label: 'Last Element',
							placeholder: 'Enter Last Element',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'angle',
							label: 'Angle',
							placeholder: 'Enter Angle',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'db',
							label: 'dB',
							placeholder: 'Enter dB',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'frequency',
							label: 'Frequency (MHZ)',
							placeholder: 'Enter Frequency (MHZ)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'manufacturer',
							label: 'Manufacturer',
							placeholder: 'Enter Manufacturer',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				{this.renderButton('Submit')}
			</form>
		);
	}
}

export default PAUTItemForm;
